var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background-recovery{background:url(" + escape(require("../../assets/recovery/qrRegister.png")) + ") no-repeat 50% fixed;background-size:cover}", ""]);

// exports
